import { PeriodTypes } from './period'

export class PeriodProperties {
  static getCurrentYearPeriods = (periods: PeriodTypes.Light[]) => {
    return periods.filter(
      (period) =>
        new Date(period.startDate).getFullYear() === new Date().getFullYear() ||
        new Date(period.endDate).getFullYear() === new Date().getFullYear()
    )
  }
}
